import React, { useEffect, useState } from 'react';
import { Button, ConfigProvider, Layout, Space } from "antd";
import { Link, Outlet, useNavigate, useParams } from "react-router-dom";
import './layout.css'
import Header from './header/header';
import CollapsibleMenu from './collapsible-menu/collapsible-menu';
import { USER_ROLES, getCurrentUser } from '../services/User';
import { LeftOutlined, PrinterOutlined } from '@ant-design/icons';
import { COUNTRY_CODES, Country, CountryService } from '../services/Country';
import ReactCountryFlag from 'react-country-flag';
import { ItemsProvider } from './itemContext/itemContext';
const { Content } = Layout;

const flagStyle = {
    height:'20px',
    width: 'auto',
    borderRadius: '3px'
}

function LayoutHome() {
  const user = getCurrentUser();
  const params = useParams();
  const navigate = useNavigate();
  const [country, setCountry] = useState<Country>()

  useEffect(() => {
    const getCountry = async() => {
      let {data} = await CountryService.getById(params.country!);
      setCountry(data);
    }

    getCountry();
    
  }, [params.country])

  const backAllCountries = () => {
    navigate('/', {replace: true})
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            darkItemBg: '#006eb5',
            darkSubMenuItemBg: '#006eb5',
            darkItemColor: 'white',
            darkItemSelectedBg: 'rgb(0 0 0 / 22%)'
          },
          Table: {
            headerBg: '#91cbf0;',
            rowHoverBg:'#ededed'
          }
        },
        token: {
          colorPrimary: '#006eb5'
        }
      }
      }
    >
      <ItemsProvider>
        <Layout style={{ height: '100vh' }}>
          <Header />
          <div className='country-name'>
              <Space>
                <Button onClick={backAllCountries} type='text'>
                    <LeftOutlined/>
                </Button>
                <ReactCountryFlag countryCode={COUNTRY_CODES[country?.name as keyof typeof COUNTRY_CODES]} svg style={flagStyle}/>
                <span><b>{country?.name}</b></span>
              </Space>
              <Link to={`/${country?._id}/print/`} target='_blank' className='button-link'><PrinterOutlined style={{marginRight:8}}/> Print Complete SOP</Link>
              
          </div>
          <Layout style={{ display: 'flex', flexDirection: 'row' }}>
            <CollapsibleMenu />
            <Content className='content-main' id='content-main'>
              <Layout className='layout' style={{marginTop:0}}>
                <Content className="layout-content">
                  <Outlet />
                </Content>
              </Layout>
            </Content>
          </Layout>
        </Layout>
      </ItemsProvider>
    </ConfigProvider>
  )
}

export default React.memo(LayoutHome);